import type { I18nTranslations } from "./types"

export const enTranslations: I18nTranslations = {
  dashboard: {
    title: "Dashboard",
    welcome: "Welcome back",
    editMode: "Edit Widgets",
  },
}
